var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagOfEgypt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 44,
    viewBox: "0 0 64 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 43,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_217_3",
    transform: "scale(0.015625 0.0232558)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_217_3",
    width: 64,
    height: 43,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAArCAYAAADIWo5HAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACMElEQVRoge2ZwWrUQBiAv0yymZhtu12trW3VUtp6KuihID6IIL5BvXns2SfwFTz24s2DiHrzJNSLlIoo2IJSabd1092YyfweIoIvMD+0+Y5hIB9fJjMZEr3vrwkXGKMtoE0bQFtAmzaAtoA2bQBtAW3aANoC2rQBtAW0aQNoC2gTHT1/oXIa9O6M4c8dbHcRO7mkoQBA5L1XCeDKI46/vSKfvkV35o6GAqD4CiT2MtnkEt5XWgqNR8ibnX5/h+0uEpkEX5e4coBJLjEa7BF3JhDvKIsDpq7dC+YUNMCP3WeYxHL99mPiTpfE9iEydLIr1NUv9j88xbvx+Q0AMD79yt7bTUYnn1i++wSA3ZcPyXqrmDglzeeD+gRfA+pqiIktSLP2CoKIx8SWuhqG1gkbQKTGuxGJ7ZPms/+up/kcie3j3QgRF1IpbIDmCQsmyVhYf0Saz2PzeRbWNzFJBgh1VYRUChvAVwUiIPVvst4KxwevGRy8IeutIL5CpBkTkrAzwBWk+RxXV++DeIrDHYaHOyCe2bUH2O4CtTvHAeJ0ipsbW4A0i54bUdcjTGwRX3FzY4sknQ6pFPZTeHzymeL4I51shnK4/3c38GBi4k6XCIOduEHWWwmlFHYGJFkffI13BVKXiDgEwcQZ1dkhrhw0YwISbW9vBz0M+bpkfPoF8f9vd5FJyKaWm1kRkAhof45eZNoA2gLatAG0BbRpA2gLaNMG0BbQpg2gLaBNG0BbQJs/WH3E7DQ9xSwAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfEgypt);
export default __webpack_public_path__ + "static/media/Flag_of_Egypt.5826645eb7ad34c328dbea151b8de9af.svg";
export { ForwardRef as ReactComponent };